import { DEFAULT_DEPOSIT_SLIPPAGE } from "../../constants";
import { WAD } from "../../utils/bigint";
const calculateMinimumMint = (depositAmount, rate, slippage) => {
  if (!slippage) {
    slippage = DEFAULT_DEPOSIT_SLIPPAGE;
  }
  const slippageAsBigInt = BigInt(slippage) * WAD.bigint / BigInt(1e4);
  const minimumMint = depositAmount * WAD.bigint / rate;
  const slippageAmount = minimumMint * slippageAsBigInt / WAD.bigint;
  return minimumMint - slippageAmount;
};
export {
  calculateMinimumMint
};
//# sourceMappingURL=utils.mjs.map